import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import { getCorrespondantRoutine, postCorrespondantRoutine, putCorrespondantRoutine, deleteCorrespondantRoutine, getCorrespondantsRoutine } from './routines';

const initialState = {
  correspondants: {
    result: [],
    error: null,
    loading: false,
  }
}

export const subCorrespondantsReducer = handleActions({

  [combineActions(getCorrespondantRoutine.TRIGGER, getCorrespondantsRoutine.TRIGGER, postCorrespondantRoutine.TRIGGER, putCorrespondantRoutine.TRIGGER, deleteCorrespondantRoutine.TRIGGER)]: (state, action) => ({
    ...state,
    loading: true
  }),

  [combineActions(getCorrespondantRoutine.SUCCESS, postCorrespondantRoutine.SUCCESS, putCorrespondantRoutine.SUCCESS)]: (state, action) => ({
    ...state,
  }),

  [getCorrespondantsRoutine.SUCCESS] : (state, action) => ({
    ...state,
    result: action.payload.result
  }),

  [deleteCorrespondantRoutine.SUCCESS] : (state, action) => ({
    ...state
  }),

  [combineActions(getCorrespondantRoutine.FAILURE, getCorrespondantsRoutine.FAILURE, postCorrespondantRoutine.FAILURE, putCorrespondantRoutine.FAILURE, deleteCorrespondantRoutine.FAILURE)]: (state, action) => ({
    ...state,
    error: action.payload
  }),

  [combineActions(getCorrespondantRoutine.FULFILL, getCorrespondantsRoutine.FULFILL, postCorrespondantRoutine.FULFILL, putCorrespondantRoutine.FULFILL, deleteCorrespondantRoutine.FULFILL)]: (state, action) => ({
    ...state,
    loading: false
  }),
},
initialState.correspondants,
);

export const correspondantsReducer = combineReducers({
  correspondants: subCorrespondantsReducer,
})